import api from "@/plugins/api/EntryPoint";
export default {
  authenticate(cb) {
    return api.post("userAuth", cb);
    },
  async getPhoneNumber(callBackFn) {
    await api.get(`settings/phone`, callBackFn);
  },
};
